import { render, staticRenderFns } from "./bulk-recipients-remove-recent-orders.vue?vue&type=template&id=94cf1bba&scoped=true&"
import script from "./bulk-recipients-remove-recent-orders.vue?vue&type=script&lang=js&"
export * from "./bulk-recipients-remove-recent-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf1bba",
  null
  
)

export default component.exports